const currency = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

const currencyCents = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
});

const percent = new Intl.NumberFormat("en-US", {
  style: "percent",
  maximumFractionDigits: 1,
});

export function fmtMoney(n: number): string {
  return currency.format(n);
}

export function fmtMoneyCents(n: number): string {
  return currencyCents.format(n);
}

export function fmtPct(n: number): string {
  return percent.format(n);
}

export function fmtAge(years: number, months: number): string {
  if (months === 0) return `${years}`;
  return `${years} yr ${months} mo`;
}
